import React, { useState, useEffect } from "react";

import axios from "axios";

import styles from "../pages/add-edit-product/c-specification-slider/components/specificationButtonViewContainer/ProductSpecificationBtnViewStyle.scss";

const ProductBankFields = (props) => {
  const { productId, token, newProfile } = props;
  const [toggleShowMore, setToggleShowMore] = useState(true);
  const [dataFields, setdataFields] = useState([]);
  const maxProps = 5;
  let productBankData = [];

  const fetchProductBankData = () => {
    const apiEndpoint = `/vendorapis/products/product/fetchTemplateProductById?productId=${productId}&token=${token}&viaSuggested=1&newProfile=${newProfile}`;
    axios.get(apiEndpoint).then((apiData) => {
      if (apiData.data.errors.code == 0 && apiData.data.data?.length) {
        productBankData.push({
          name: "category",
          value: apiData.data.data[0]?.category
            ? apiData.data.data[0]?.category
            : "",
        });


        productBankData.push({
          name: "Brand",
          value: apiData.data.data[0]?.brand
            ? apiData.data.data[0]?.brand
            : "",
        });
  
        if ((apiData.data.data[0]?.mrp).toString()) {
          productBankData.push({name : 'mrp',value : apiData.data.data[0].mrp})
        }

        if(apiData.data.data[0]?.productName) {
          productBankData.push({name : 'Product Display Name',value : apiData.data.data[0].productName})
        }

        if (apiData.data.data[0]?.detailsSpecification?.length) {
          apiData.data.data[0].detailsSpecification.map((element, index) => {
            productBankData.push({ name: element.sdn, value: element.sdv });
          });
        }
      }
      setdataFields(productBankData);
    });
  };

  useEffect(() => {
    fetchProductBankData();
  }, []);

  function showMoreHandle() {
    const container = document.querySelector(".add-edit-container");
    if (container) {
      const wrapper = container.querySelector(
        ".collapsible-div .wrapped-component"
      );
      if (!!wrapper) {
        toggleShowMore
          ? wrapper.classList.add("increase-height")
          : wrapper.classList.remove("increase-height");
      }
    }
    setToggleShowMore(!toggleShowMore);
  }

  const dataToRender = toggleShowMore
    ? dataFields.slice(0, maxProps)
    : dataFields;

  return (
    <>
      {
        <div
          className={`${styles["section-container"]} ${styles["edit-mode"]}`}
          style={{ paddingTop: "15px" }}
        >
          <div className={`${styles["head-text"]} ${styles["spec-view"]}`}>
            <span>Product Bank Information</span>
          </div>

          <ul className={styles["specification-list"]}>
            {dataToRender.map((item, index) => {
              return (
                <li key={`${item.name}-${item.index}`}>
                  <span className={styles["specification-item-key"]}>
                    {item.name}
                  </span>
                  <span className={styles["specification-item-value"]}>
                    {item.value}
                  </span>
                </li>
              );
            })}
          </ul>
          {dataFields.length > maxProps && (
            <div className={styles["show-more-btn-wrapper"]}>
              <div className={styles["show-more-btn"]} onClick={showMoreHandle}>
                <span className={`${styles["toggleicon"]}`}>
                  {toggleShowMore ? "+" : "-"}
                </span>
                <span className={styles["toggle-btn-text"]}>
                  View {toggleShowMore ? "More" : "Less"}
                </span>
              </div>
            </div>
          )}
        </div>
      }
    </>
  );
};

export default ProductBankFields;
